/* eslint-disable import/no-extraneous-dependencies */

import React from 'react';
import styled from 'styled-components';

import Admin from 'hive-admin';

import getFilterWithCol from '../../../helpers/getFilterWithCol';
import { sizeChoices } from '../helpers';

// import Types from '../../../common/modules/types';

const isNotBorderRadius = Admin.compileFromLibrary([
  'condition.testFieldValue',
  'type',
  '!==',
  'BORDER_RADIUS',
]);

const isNotBorderRadiusSizeCustom = Admin.compileFromLibrary([
  'condition.testFieldValue',
  'border_radius_size',
  '!==',
  'CUSTOM',
]);

const Icon = styled.div`
  width: 10px;
  height: 10px;
  &[data-border-left="true"] { border-left: 1px solid black; }
  &[data-border-right="true"] { border-right: 1px solid black; }
  &[data-border-top="true"] { border-top: 1px solid black; }
  &[data-border-bottom="true"] { border-bottom: 1px solid black; }
  border-color: ${({ theme }) => theme.less.textColor} !important;
`;

export default [
  ...[
    ['FieldRadio', {
      label: null,
      name: 'border_radius_size',
      initialValue: 'MEDIUM',
      block: true,
      choices: [
        ...sizeChoices,
        {
          label: 'Custom',
          value: 'CUSTOM',
        },
      ],
    }],
    ...[
      ['Top Left', 'topLeft', ['top', 'left']],
      ['Top Right', 'topRight', ['top', 'right']],
      ['Bottom Right', 'bottomRight', ['bottom', 'right']],
      ['Bottom Left', 'bottomLeft', ['bottom', 'left']],
    ].map(([_label, name, borders]) => getFilterWithCol(['FieldText', {
      label: null,
      name: `border_radius_custom.${name}`,
      prefix: (
        <Icon
          {...borders.reduce(
            (agr, border) => {
              agr[`data-border-${border}`] = true;
              return agr;
            },
            {},
          )}
        />
      ),
      skip: [isNotBorderRadiusSizeCustom],
      align: 'center',
    }], 6)),
  ].map(([fieldType, fieldConfig]) => Admin.compileFromLibrary([
    fieldType,
    {
      ...fieldConfig,
      preSkip: [isNotBorderRadius, ...(fieldConfig.preSkip || [])],
    },
  ])),
];
